<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
    
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Developed by
        <a href="#" target="_blank" rel="noopener"
          >Leonardo Martino</a
        >. based on a
        <a href="https://www.creative-tim.com/license" target="_blank" rel="noopener"
          >Creative tim design</a
        >&nbsp; and images <a href="http://www.freepik.com" target="_blank" rel="noopener">Designed by Freepik</a>
        
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
